import BgvStepsSection from "../ItPage/BgvStepsSection/BgvStepsSection";
import TestimonialSection from "../HomePage/TestimonialSection/TestimonialSection";
import FaqComponent from "../../Components/Footer/FaqComponent/FaqComponent";
import HelpCard from "../../Components/Footer/HelpCenterCard/HelpCard";
import PortalSection3 from "./Portal_Section_3";
import { Helmet } from "react-helmet";
import ButtonComponent from "../../Components/Buttons/ButtonComponent";
import Self_Verification_Section from "./Self_Verification_Section";
import BrandCarousel from "../ItPage/BrandCarousel/BrandCarousel";
const digitalOceanURL =
  "https://hirestarorg.blr1.digitaloceanspaces.com/Hirestar-Landing-Page/assets";

const Self_Verification_Image = `${digitalOceanURL}/Portal_Image/Self_Verification_Image.png`;
const Self_Verification_Small_Image = `${digitalOceanURL}/Portal_Image/Self_Verification_small_Image.png`;
const jsonLdData = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "SoftwareApplication",
      "@id": "https://hirestar.io/self-verification#software",
      name: "HireStar.io Self-Verification Portal",
      operatingSystem: "Web",
      applicationCategory: "BusinessApplication",
      description:
        "HireStar.io's Self-Verification Portal empowers individuals to conduct their own background checks, streamlining HR processes and ensuring accurate, blockchain-secured verification of employment and educational credentials.",
      url: "https://hirestar.io/self-verification",
      publisher: {
        "@id": "https://hirestar.io/#organization",
      },
    },
    {
      "@type": "WebPage",
      "@id": "https://hirestar.io/self-verification",
      url: "https://hirestar.io/self-verification",
      name: "HireStar.io Self-Verification Portal",
      description:
        "Access HireStar.io's Self-Verification Portal to independently verify your background information, enhancing transparency and efficiency in the hiring process.",
      publisher: {
        "@id": "https://hirestar.io/#organization",
      },
    },
    {
      "@type": "Organization",
      "@id": "https://hirestar.io/#organization",
      name: "HireStar.io",
      url: "https://hirestar.io",
      logo: {
        "@type": "ImageObject",
        url: "https://hirestarorg.blr1.digitaloceanspaces.com/Hirestar-Landing-Page/assets/HeaderAssets/hireStar.svg",
      },
      sameAs: [
        "https://in.linkedin.com/showcase/hirestar.io/",
        "https://www.facebook.com/hirestario",
        "https://twitter.com/Hirestario?t=YOq_b92bZL8gZxDuS21hRQ&s=09",
        "https://www.instagram.com/hirestar.io/",
      ],
    },
    {
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://hirestar.io/",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Self-Verification Portal",
          item: "https://hirestar.io/self-verification",
        },
      ],
    },
  ],
};

export default function Self_Verification() {
  return (
    <>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(jsonLdData)}</script>
        <title>
          Reliable Self-Verification Portal for Background Checks | Hirestar.io
        </title>
        <meta
          name="description"
          content="Hirestar.io’s self-verification portal empowers employees to manage their own background checks, reducing HR workload while ensuring faster, accurate, and compliant verifications."
        />
        <meta
          name="keywords"
          content="Hirestar.io self-verification portal, employee background checks, HR automation, streamline HR processes, background verification solution, Hirestar.io, compliance and transparency, reduce HR workload, faster background checks, HR tech innovation"
        />
        <meta
          property="og:title"
          content="Reliable Self-Verification Portal for Background Checks | Hirestar.io"
        />
        <meta
          property="og:description"
          content="Hirestar.io’s self-verification portal empowers employees to manage their own background checks, reducing HR workload while ensuring faster, accurate, and compliant verifications."
        />
        <meta property="og:url" content="https://hirestar.io/hr-portal" />
        <meta name="robots" content="index, follow" />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://hirestarorg.blr1.digitaloceanspaces.com/Hirestar-Landing-Page/assets/Portal_Image/Self_Verification_Image.png"
        />
        <meta property="og:image:type" content="image/png" />
        <meta property="og:site_name" content="Hirestar.io" />
        <link
          rel="canonical"
          href={`https://hirestar.io${window.location.pathname}`}
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Reliable Self-Verification Portal for Background Checks | Hirestar.io"
        />
        <meta
          name="twitter:description"
          content="Hirestar.io’s self-verification portal empowers employees to manage their own background checks, reducing HR workload while ensuring faster, accurate, and compliant verifications."
        />
        <meta
          name="twitter:image"
          content="https://hirestarorg.blr1.digitaloceanspaces.com/Hirestar-Landing-Page/assets/Portal_Image/Self_Verification_Image.png"
        />
        <meta property="og:locale" content="en_US" />
      </Helmet>
      <div className=" relative overflow-hidden blog_bg_image mb-24 lg:mb-0 background_color">
        {/* ---------------------------show this for lg and md device------------------------------------- */}
        <div className="lg:relative   lg:top-8 flex flex-col   lg:mx-12 top_image_gap ">
          <div className=" flex flex-col lg:relative  lg:right-10 leading-tight z-[2] Self-portal-box ">
            <div className="p-2 mt-4  lg:ml-16 top_spacing">
              <div
                aria-label="Introducing the Hirestar.io Self Verification Portal"
                className="text-wrap mt-14 lg:mt-0 md:mt-20 text-heading-container  font-semibold font-[poppins] text-center heading "
              >
                {/* <h1 className="text-[32px] md:text-[46px] lg:text-[46px]" aria-label="Introducing the Hirestar.io Self Verification Portal">
                                    Introducing the Hirestar.io <br /> <span className='text-[#1783C4]'>Self Verification Portal</span>
                                </h1> */}

                {/* updated-----------heading */}
                <h1
                  className="text-[32px] md:text-[46px] lg:text-[46px]"
                  aria-label="Introducing the Hirestar.io"
                >
                  Introducing The Hirestar.io
                </h1>
                <p
                  className="text-[32px] md:text-[46px] lg:text-[46px] text-[#1783C4]"
                  aria-label=" Self Verification Portal"
                >
                  Self Verification Portal
                </p>
              </div>
              <div className="text-wrap px-2 lg:px-0 md:px-0  font-[poppins] font-[16px] mt-4 md:mt-6 lg:mt-4 text-center paragraph">
                <p>
                  Streamline hiring with secure, blockchain-based background
                  checks <br className="hidden md:block lg:block " />
                  Trust Hirestar.io for verified and transparent employee
                  screening
                </p>
              </div>
            </div>

            {/* --------------------------buttons-------------------- */}
            <ButtonComponent
              arialLabel={
                "Get in touch with an expert to know more about Self Verification Portal"
              }
            />
          </div>

          {/* -------------------------show this for large device-------------------------------------- */}
          <div className="self-image">
            {/* Home Image */}
            <img
              className="home-image lg:mb-12 lg:relative w-full lg:top-0"
              alt="hero img for self verification"
              title="home image for self verification"
              src={Self_Verification_Image}
              loading="lazy"
            />
          </div>

          {/* -------------------------show this for small device-------------------------------------- */}
          <div className="relative w-full max-w-sm mx-auto small-image mb-20">
            <div className="overflow-hidden rounded-lg">
              <div className="flex transition-transform duration-300 ease-in-out">
                <img
                  loading="lazy"
                  src={Self_Verification_Small_Image}
                  alt="hero img small for self verification"
                  title="small screen hero img for self verification"
                  className="w-full h-auto flex-shrink-0"
                />
              </div>
            </div>
          </div>

          {/* ------------------------dot code to show  current image -------------------- */}
        </div>
      </div>
      <div className="mt-20">
        <BrandCarousel />
      </div>
      <Self_Verification_Section />
      <PortalSection3
        heading="Self Verification Portal"
        Paragraph="Experience seamless HR processes with Hirestar.io, a AI & blockchain-powered background verification solution. Simplify pre-joining checks and elevate your HR management."
        section="Self_Verification"
      />
      <BgvStepsSection />
      <div>
        <TestimonialSection />
      </div>
      <FaqComponent />
      <div className="relative top-28  left-0 right-0">
        <HelpCard />
      </div>
    </>
  );
}
